module.exports = __webpack_public_path__ + "static/media/xxJyPie.3e9f798e.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/xxJyPie.png
// module id = 1876
// module chunks = 0 1